import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from './auth-service.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService  implements CanActivate {

  public userDetails: firebase.User = null;
  constructor(private auth: AuthService, private router: Router) { }

  canActivate() {
    if (this.auth.isLoggedIn()){
      
      this.userDetails = JSON.parse(localStorage.getItem('userAuth'));
      if (this.userDetails?.emailVerified){
        return true;
      }else{
        this.router.navigate(['auth/verify-account'])
      }

    }else{
      this.router.navigate(['auth/login'])
    }
  }
}
